import {Injectable, Type} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from '../../../../core/shared/service/crud/mvs-crud.service';
import {MvsCrudModeEnum} from '../../../../core/shared/service/crud/mvs-crud-mode.enum';

/**
 * [CW-COVERAGE-PREMIUM] Generic CRUD service of {@code cw.CwCaseProductCoveragePrice}
 * ({@code /mvsa/cw/cwCaseProductCoveragePrices}) — the DELIVERED premium share per Leistungsbaustein.
 *
 * <h3>Read-only in practice</h3>
 * The rows are written server-side while the partner answer (BiPRO/TAA) is mapped onto the price
 * row: they are the received values, stored unchanged (decision L-3). A client-side write would
 * fabricate a share the insurer never sent and would be overwritten by the next pricing event
 * anyway. The service exists so the alias resolves to a REAL CRUD service — an UNREGISTERED alias
 * answers an empty list instead of failing, which makes a missing display look like a backend bug.
 *
 * <h3>What consumers must not do with the result</h3>
 * Never aggregate. The Baustein shares do not necessarily add up to the person share or to the
 * delivered total and are not corrected (see {@code CwCaseProductCoveragePriceDto}). A row without
 * {@code cwCaseProductCoverageDtoId} or without {@code cwCaseProductPersonDtoId} is a valid row and
 * must stay in the list.
 *
 * <p>Note the endpoint spelling: {@code cwCaseProductCoveragePrices} carries the module prefix, like
 * its parent {@code cw.CwCaseProductPrice} ({@code /cw/cwCaseProductPrices}) and unlike the
 * person/role family ({@code /cw/caseProductPersonRoles}). Taken verbatim from the backend
 * {@code @RequestMapping}.
 */
@Injectable({
    providedIn: 'root',
})
export class CwCaseProductCoveragePriceService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/cw/cwCaseProductCoveragePrices');
    }

    getObjectComponent(mode: MvsCrudModeEnum = MvsCrudModeEnum.update): Type<any> {
        return null;
    }

}
